import { ComposerActionHeader, ComposerActionRadioGroup } from 'components/composer/composer-actions-components';
import { FlowBody } from 'utils/flow';

const options = [
	{ value: 'autonomous', label: 'Autonomous', description: 'Act without asking for approval.' },
	{
		value: 'critical',
		label: 'Critical actions',
		description: 'Ask before production, destructive, security, or other high-impact changes.',
	},
	{ value: 'all', label: 'All actions', description: 'Ask for approval before making any change.' },
];

const ComposerActionsPermissions = ({ disabled = false, permissions = 'critical', onChange, onPrev }) => (
	<>
		<ComposerActionHeader title='Permissions' onPrev={onPrev} />
		<FlowBody>
			<ComposerActionRadioGroup
				idPrefix='composer-permissions'
				value={permissions}
				options={options}
				disabled={disabled}
				onValueChange={onChange}
			/>
		</FlowBody>
	</>
);

export { ComposerActionsPermissions };
